"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityPlatformFeeDto = instanceOfFacilityPlatformFeeDto;
exports.FacilityPlatformFeeDtoFromJSON = FacilityPlatformFeeDtoFromJSON;
exports.FacilityPlatformFeeDtoFromJSONTyped = FacilityPlatformFeeDtoFromJSONTyped;
exports.FacilityPlatformFeeDtoToJSON = FacilityPlatformFeeDtoToJSON;
exports.FacilityPlatformFeeDtoToJSONTyped = FacilityPlatformFeeDtoToJSONTyped;
/**
 * Check if a given object implements the FacilityPlatformFeeDto interface.
 */
function instanceOfFacilityPlatformFeeDto(value) {
    if (!('platformFeePct' in value) || value['platformFeePct'] === undefined)
        return false;
    return true;
}
function FacilityPlatformFeeDtoFromJSON(json) {
    return FacilityPlatformFeeDtoFromJSONTyped(json, false);
}
function FacilityPlatformFeeDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'platformFeePct': json['platformFeePct'],
    };
}
function FacilityPlatformFeeDtoToJSON(json) {
    return FacilityPlatformFeeDtoToJSONTyped(json, false);
}
function FacilityPlatformFeeDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'platformFeePct': value['platformFeePct'],
    };
}
//# sourceMappingURL=FacilityPlatformFeeDto.js.map